export default "__VITE_ASSET__DGijMoxm__"